<template>
  <div class="app-container">
    <el-form
      :model="noteForm"
      ref="noteForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
      size="medium"
    >
      <el-form-item label="个推AppID" prop="appid">
        <el-input
          v-model="noteForm.appid"
          :disabled="cztype == 'see'"
          placeholder="请输入个推AppID"
        ></el-input>
      </el-form-item>
      <el-form-item label="个推AppSecret" prop="app_secret">
        <el-input
          v-model="noteForm.app_secret"
          :disabled="cztype == 'see'"
          placeholder="请输入个推AppSecret"
        ></el-input>
      </el-form-item>
      <el-form-item label="个推AppKey" prop="appkey">
        <el-input
          v-model="noteForm.appkey"
          :disabled="cztype == 'see'"
          placeholder="请输入个推AppKey"
        ></el-input>
      </el-form-item>
      <el-form-item label="个推MasterSecret" prop="master_secret">
        <el-input
          v-model="noteForm.master_secret"
          :disabled="cztype == 'see'"
          placeholder="请输入个推MasterSecret"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="cztype == 'edit'">
        <el-button
          type="primary"
          @click="edit()"
          v-if="roles.includes('/conf/set_push')"
        >
          立即修改
        </el-button>
        <el-button type="info" @click="coles()"> 取消 </el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button type="success" @click="cztype = 'edit'"> 修改 </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getPush, setPush } from "@/api/conf";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  data() {
    return {
      noteForm: {},
      cztype: "see",
      rules: {
        appid: [
          { required: true, message: "请输入个推AppID", trigger: "blur" },
        ],
        app_secret: [
          { required: true, message: "请输入个推AppSecret", trigger: "blur" },
        ],
        appkey: [
          { required: true, message: "请输入个推AppKey", trigger: "blur" },
        ],
        master_secret: [
          {
            required: true,
            message: "请输入个推MasterSecret",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    coles() {
      this.getInfo();
      this.cztype = "see";
    },
    edit() {
      var that = this;
      setPush(this.noteForm).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          that.getInfo();
        }
      });
    },
    // LTAI5tBLribUTNddK3dcHEmf
    getInfo() {
      getPush().then((res) => {
        this.noteForm = {
          appid: res.data.appid,
          app_secret: res.data.app_secret,
          appkey: res.data.appkey,
          master_secret: res.data.master_secret,
        };
        this.cztype = "see";
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  padding: 60px;
}
</style>
